import React from 'react'
import clsx from 'clsx'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import styles from './Header.module.css'

import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import { logoutUser } from '../../actions/auth'
import { selectAuthData } from '../../store/selectors/authSelectors'


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  paper: {
    marginRight: theme.spacing(2),
  },
}));



const Header = () => {
    const dispatch = useDispatch()
    const authData = useSelector(selectAuthData)
    const history = useHistory()
    const location = useLocation()
    const isHome = location.pathname === '/'
    const [mobileNavOpen, setMobileNavOpen] = React.useState(false)

    const [servicesOpen, setServicesOpen] = React.useState(false)
    const servicesTimer = React.useRef(null)

    const openServices = () => {
      if (servicesTimer.current) clearTimeout(servicesTimer.current)
      setServicesOpen(true)
    }

    const scheduleCloseServices = () => {
      if (servicesTimer.current) clearTimeout(servicesTimer.current)
      servicesTimer.current = setTimeout(() => setServicesOpen(false), 120)
    }

    const handleServicesBlur = (e) => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setServicesOpen(false)
      }
    }

    const logout =() => {
        dispatch(logoutUser())
        history.push('/')
    }  

    const closeMobileNav = () => setMobileNavOpen(false)
    const toggleMobileNav = () => setMobileNavOpen((prev) => !prev)





  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event ) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };


  const openLink =(link) => {
      history.push(`/${link}`)
      setOpen(false);
  }

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);




    if(!authData) return (
      <>
        <div className={styles.header2}>
          <img style={{width: '50px', cursor: 'pointer'}} onClick={()=> history.push('/')} src="images/wholesale_shield.PNG" alt="arc-invoice" />
          {isHome && (
            <div className={styles.homeLinks}>
              <a href="#about">About</a>
              <div
                className={clsx(styles.dropdown, servicesOpen && styles.dropdownOpen)}
                onMouseEnter={openServices}
                onMouseLeave={scheduleCloseServices}
                onFocus={openServices}
                onBlur={handleServicesBlur}
              >
                <a href="#services" className={styles.dropdownLabel}>Services</a>
                <div className={clsx(styles.dropdownMenu, servicesOpen && styles.dropdownMenuOpen)}>
                  <a href="#services-property-managers">Property Managers</a>
                  <a href="#services-builders">Builders</a>
                  <a href="#services-retail-dealers">Retail Dealers</a>
                </div>
              </div>
              <a href="#contact">Contact</a>
            </div>
          )}
        <div className={styles.headerActions}>
          {isHome && (
            <a className={styles.homeCallButton} href="tel:15167996404">
              Call now
            </a>
          )}
          <button className={styles.mobileToggle} type="button" onClick={toggleMobileNav} aria-label="Toggle navigation">
            <span />
            <span />
            <span />
          </button>
          {!isHome && <button onClick={()=> history.push('/login')} className={styles.login}>Get started</button>}
        </div>
      </div>
        {isHome && (
          <>
            <div className={clsx(styles.mobileNav, mobileNavOpen && styles.mobileNavOpen)}>
              <a href="#about" onClick={closeMobileNav}>About</a>
              <a href="#services" onClick={closeMobileNav}>Services</a>
              <a href="#services-property-managers" onClick={closeMobileNav}>Property Managers</a>
              <a href="#services-builders" onClick={closeMobileNav}>Builders</a>
              <a href="#services-retail-dealers" onClick={closeMobileNav}>Retail Dealers</a>
              <a href="#contact" onClick={closeMobileNav}>Contact</a>
            </div>
            {mobileNavOpen && <div className={styles.mobileNavOverlay} onClick={closeMobileNav} />}
          </>
        )}
      </>
    )
    return (
      <>
        <div className={styles.header}>
          <img style={{width: '50px', cursor: 'pointer'}} onClick={()=> history.push('/dashboard')} src="images/wholesale_shield.PNG" alt="arc-invoice" />
          {isHome && (
            <div className={styles.homeLinks}>
              <a href="#about">About</a>
              <div
                className={clsx(styles.dropdown, servicesOpen && styles.dropdownOpen)}
                onMouseEnter={openServices}
                onMouseLeave={scheduleCloseServices}
                onFocus={openServices}
                onBlur={handleServicesBlur}
              >
                <a href="#services" className={styles.dropdownLabel}>Services</a>
                <div className={clsx(styles.dropdownMenu, servicesOpen && styles.dropdownMenuOpen)}>
                  <a href="#services-property-managers">Property Managers</a>
                  <a href="#services-builders">Builders</a>
                  <a href="#services-retail-dealers">Retail Dealers</a>
                </div>
              </div>
              <a href="#contact">Contact</a>
            </div>
        )}
        <div className={styles.headerActions}>
          {isHome && (
            <a className={styles.homeCallButton} href="tel:15167996404">
              Call now
            </a>
          )}
          <button className={styles.mobileToggle} type="button" onClick={toggleMobileNav} aria-label="Toggle navigation">
            <span />
            <span />
            <span />
          </button>
          <div className={classes.root}>
        <div>
          <Button
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
          >
            <Avatar style={{backgroundColor: '#1976D2'}}>{authData?.result?.name?.charAt(0)}</Avatar>
          </Button>
          <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
              >
                <Paper elevation={3}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown} >
                      <MenuItem onClick={() => openLink('dashboard')}>Dashboard</MenuItem>
                      <MenuItem onClick={() => openLink('settings') }>{(authData?.result?.name).split(" ")[0]}</MenuItem>
                      <MenuItem onClick={()=> logout()} >Logout</MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>

          </div>
        </div>
        {isHome && (
          <>
            <div className={clsx(styles.mobileNav, mobileNavOpen && styles.mobileNavOpen)}>
              <a href="#about" onClick={closeMobileNav}>About</a>
              <a href="#services" onClick={closeMobileNav}>Services</a>
              <a href="#services-property-managers" onClick={closeMobileNav}>Property Managers</a>
              <a href="#services-builders" onClick={closeMobileNav}>Builders</a>
              <a href="#services-retail-dealers" onClick={closeMobileNav}>Retail Dealers</a>
              <a href="#contact" onClick={closeMobileNav}>Contact</a>
            </div>
            {mobileNavOpen && <div className={styles.mobileNavOverlay} onClick={closeMobileNav} />}
          </>
        )}
      </>
    )
}

export default Header
